import { render, staticRenderFns } from "./base-message-v2.vue?vue&type=template&id=36169efd&scoped=true"
import script from "./base-message-v2.vue?vue&type=script&lang=js"
export * from "./base-message-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36169efd",
  null
  
)

export default component.exports